
(function(){
if(window.__sjwBg2)return;window.__sjwBg2=1;
var XICON='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>';
var WRIST='<svg class="sjw-bg2-wrist" viewBox="0 0 64 64" fill="none" aria-hidden="true"><path d="M21 6 C18.5 20 18.5 34 24 58" stroke="#C2A878" stroke-width="1.4" stroke-linecap="round"/><path d="M43 6 C45.5 20 45.5 34 40 58" stroke="#C2A878" stroke-width="1.4" stroke-linecap="round"/><path d="M17.8 33 A14.2 6 0 0 0 46.2 33" stroke="#E1D6C2" stroke-width="1.2" opacity="0.7"/><ellipse cx="32" cy="33" rx="14.2" ry="6" stroke="#C2A878" stroke-width="1.4"/><path d="M32 27.4 L36 33 L32 38.6 L28 33 Z" fill="#E1D6C2" stroke="#C2A878" stroke-width="1"/></svg>';
var RULERIC='<svg class="sjw-bg2-ruleric" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="2.5" y="8" width="19" height="8" rx="1.6" stroke="#9C7B3F" stroke-width="1.4"/><path d="M7 8v3.4 M12 8v4.4 M17 8v3.4" stroke="#9C7B3F" stroke-width="1.3" stroke-linecap="round"/></svg>';
var FITS=[['Snug',0.5],['Comfort',0.75],['Relaxed',1.25]];
var PR='″';
function fmt(n){return (Math.round(n*10)/10).toString();}
function sizesOf(lenrow){
var out=[];
[].forEach.call(lenrow.querySelectorAll('.sjwpp-lenpill .lv'),function(el){
var v=parseFloat(el.textContent);if(!isNaN(v)&&out.indexOf(v)<0)out.push(v);
});
return out.sort(function(a,b){return a-b;});
}
function pillFor(lenrow,size){
var hit=null;
[].forEach.call(lenrow.querySelectorAll('.sjwpp-lenpill'),function(p){
var lv=p.querySelector('.lv');if(lv&&parseFloat(lv.textContent)===size)hit=p;
});
return hit;
}
function build(lenrow){
var sizes=sizesOf(lenrow);
var minS=sizes[0],maxS=sizes[sizes.length-1];
var wmin=Math.max(4,Math.round((minS-1.5)*10)/10),wmax=Math.round((maxS-0.3)*10)/10;
var wspan=(wmax-wmin)||1,THUMB=14;
var wval=Math.round((wmin+wmax)/2*10)/10,fitI=1;
var ov=document.createElement('div');ov.className='sjw-bg2-ov';
ov.setAttribute('role','dialog');ov.setAttribute('aria-modal','true');ov.setAttribute('aria-label','Find your bracelet size');
var rows='';
sizes.forEach(function(s){
rows+='<li class="sjw-bg2-row" data-s="'+s+'"><span class="sjw-bg2-rangetxt">'+fmt(s-1.2)+'&ndash;'+fmt(s-0.5)+'&Prime;</span><button type="button" class="sjw-bg2-chip" data-use="'+s+'">'+fmt(s)+'&Prime;</button></li>';
});
var fitBtns='';
FITS.forEach(function(f,i){
fitBtns+='<button type="button" class="sjw-bg2-fit'+(i===fitI?' on':'')+'" data-i="'+i+'"><span class="sjw-bg2-fitname">'+f[0]+'</span><span class="sjw-bg2-fitadd">+'+f[1]+'&Prime;</span></button>';
});
ov.innerHTML='<div class="sjw-bg2-modal">'
+'<div class="sjw-bg2-head"><div class="sjw-bg2-eyebrow">Signora &middot; Atelier</div><div class="sjw-bg2-title">Find your bracelet size</div><button type="button" class="sjw-bg2-x" aria-label="Close">'+XICON+'</button></div>'
+'<div class="sjw-bg2-rule"></div>'
+'<section class="sjw-bg2-step"><div class="sjw-bg2-stephead"><span class="sjw-bg2-num">01</span><span class="sjw-bg2-steplabel">Measure your wrist</span></div><div class="sjw-bg2-measure">'+WRIST+'<p class="sjw-bg2-instr">'+RULERIC+'Wrap a paper strip around your wrist just past the bone, mark the overlap, and measure it flat in inches.</p></div></section>'
+'<section class="sjw-bg2-step"><div class="sjw-bg2-stephead"><span class="sjw-bg2-num">02</span><span class="sjw-bg2-steplabel">Your wrist</span></div><div class="sjw-bg2-tapewrap"><div class="sjw-bg2-flag"><span class="sjw-bg2-flagval">'+wval.toFixed(1)+'&Prime;</span></div><div class="sjw-bg2-tapebar"><div class="sjw-bg2-ticks"></div><input class="sjw-bg2-range" type="range" min="'+wmin+'" max="'+wmax+'" step="0.1" value="'+wval+'" aria-label="Wrist measurement in inches"></div></div></section>'
+'<section class="sjw-bg2-step"><div class="sjw-bg2-stephead"><span class="sjw-bg2-num">03</span><span class="sjw-bg2-steplabel">How do you wear it</span></div><div class="sjw-bg2-fits" role="group" aria-label="Fit preference">'+fitBtns+'</div></section>'
+'<div class="sjw-bg2-plate"><div class="sjw-bg2-plateinner"><div class="sjw-bg2-plateeyebrow">WE SUGGEST</div><div class="sjw-bg2-platerow"><div class="sjw-bg2-plateval" data-sugv></div><button type="button" class="sjw-bg2-use">Use</button></div><div class="sjw-bg2-why"></div></div></div>'
+'<div class="sjw-bg2-chart"><div class="sjw-bg2-charthead"><span>Your wrist</span><span class="sjw-bg2-arw">&rarr;</span><span>We suggest</span></div><ul class="sjw-bg2-rows">'+rows+'</ul></div>'
+'<p class="sjw-bg2-foot">Measure at day&rsquo;s end &middot; between sizes, size up</p>'
+'</div>';
document.body.appendChild(ov);
var sl=ov.querySelector('.sjw-bg2-range'),
flag=ov.querySelector('.sjw-bg2-flag'),
flagVal=ov.querySelector('.sjw-bg2-flagval'),
ticks=ov.querySelector('.sjw-bg2-ticks'),
sugv=ov.querySelector('[data-sugv]'),
why=ov.querySelector('.sjw-bg2-why'),
use=ov.querySelector('.sjw-bg2-use'),
chart=ov.querySelector('.sjw-bg2-chart');
var pick=maxS;
(function(){
var lo=Math.round(wmin*10),hi=Math.round(wmax*10),html='';
for(var i=lo;i<=hi;i++){
var v=i/10,p=((v-wmin)/wspan*100).toFixed(3),maj=(i%5===0);
html+='<span class="sjw-bg2-tk '+(maj?'maj':'min')+'" style="left:'+p+'%"></span>';
if(maj){
var tx=(i===lo)?'translateX(0)':(i===hi?'translateX(-100%)':'translateX(-50%)');
html+='<span class="sjw-bg2-tkl" style="left:'+p+'%;transform:'+tx+'">'+v.toFixed(1)+'</span>';
}
}
ticks.innerHTML=html;
})();
function positionFlag(v){
var p=(v-wmin)/wspan,corr=(0.5-p)*THUMB,sign=corr>=0?'+':'-';
flag.style.left='calc('+(p*100).toFixed(3)+'% '+sign+' '+Math.abs(corr).toFixed(2)+'px)';
}
function calc(){
var w=parseFloat(sl.value),add=FITS[fitI][1],name=FITS[fitI][0].toLowerCase();
var target=w+add,capped=true;pick=maxS;
for(var i=0;i<sizes.length;i++){if(sizes[i]>=target-0.05){pick=sizes[i];capped=false;break;}}
flagVal.textContent=w.toFixed(1)+PR;
positionFlag(w);
sugv.textContent=fmt(pick)+PR;
use.textContent='Use '+fmt(pick)+PR;
why.textContent=capped?('our longest length for a '+w.toFixed(1)+PR+' wrist'):(w.toFixed(1)+PR+' wrist + '+add+PR+' '+name);
[].forEach.call(chart.querySelectorAll('.sjw-bg2-row'),function(r){
r.classList.toggle('on',parseFloat(r.getAttribute('data-s'))===pick);
});
}
function commit(size){var p=pillFor(lenrow,size);if(p)p.click();close();}
function open(){ov.__lastFocus=document.activeElement;ov.classList.add('on');document.body.style.overflow='hidden';calc();var x=ov.querySelector('.sjw-bg2-x');if(x)x.focus();}
function close(){ov.classList.remove('on');document.body.style.overflow='';if(ov.__lastFocus&&ov.__lastFocus.focus)try{ov.__lastFocus.focus();}catch(err){}}
ov.__close=close;
sl.addEventListener('input',calc);
[].forEach.call(ov.querySelectorAll('.sjw-bg2-fit'),function(b){
b.addEventListener('click',function(){
fitI=parseInt(b.getAttribute('data-i'),10);
[].forEach.call(ov.querySelectorAll('.sjw-bg2-fit'),function(x){x.classList.remove('on');});
b.classList.add('on');calc();
});
});
use.addEventListener('click',function(){commit(pick);});
[].forEach.call(ov.querySelectorAll('[data-use]'),function(c){
c.addEventListener('click',function(e){e.stopPropagation();commit(parseFloat(c.getAttribute('data-use')));});
});
ov.querySelector('.sjw-bg2-x').addEventListener('click',close);
ov.addEventListener('click',function(e){if(e.target===ov)close();});
calc();
return {open:open};
}
document.addEventListener('keydown',function(e){
var ov=document.querySelector('.sjw-bg2-ov.on');if(!ov)return;
if(e.key==='Escape'){if(ov.__close)ov.__close();return;}
if(e.key==='Tab'){
var f=ov.querySelectorAll('button, input, [href]');
if(!f.length)return;
var first=f[0],last=f[f.length-1];
if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
}
});
document.addEventListener('click',function(e){
var fb=e.target.closest?e.target.closest('[data-sjw-bgopen]'):null;
if(!fb)return;
var card=fb.closest('.sjwpp-lencard');if(!card)return;
var lenrow=card.querySelector('.sjwpp-lenrow');if(!lenrow)return;
var __rn=card.querySelector('.sjwpp-rname');
if(__rn&&/necklace|chain|pendant/i.test(__rn.textContent||'')){e.preventDefault();e.stopPropagation();if(window.SJWCNG&&window.SJWCNG.openChooser)window.SJWCNG.openChooser(lenrow);return;}
if(sizesOf(lenrow).length<2)return;
e.preventDefault();e.stopPropagation();
if(!card.__sjwBg2)card.__sjwBg2=build(lenrow);
card.__sjwBg2.open();
},true);
})();
